import { useRef, useEffect, useCallback, useState, useMemo } from 'react'
import mapboxgl from '!mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'

mapboxgl.accessToken =
  'pk.eyJ1IjoibG9obWFubiIsImEiOiJjanlweGw5djQxa2c4M2pvOXl1emZtcWJhIn0.T2p0aBm9yZc7SnEr0jiHUw'

function handleMount(mountMap, unMount) {
  const ref = { current: null }

  return {
    // aqui deve fazer o mount do mapa
    set current(value) {
      if (ref.current && !value) {
        unMount && unMount()
      }

      ref.current = value

      value && mountMap(value)
    }
  }
}

export default function useMapBox(initialState, { onLoad } = {}) {
  const [state, setState] = useState(initialState)
  const [mapLoaded, setMapLoaded] = useState(false)

  const mapRef = useRef({ marker: null, map: null })
  const { center, zoom = 7, marker } = state

  const mountMap = useCallback((container) => {
    mapRef.current.map = new mapboxgl.Map({
      container,
      style: 'mapbox://styles/mapbox/outdoors-v11',
      center,
      zoom
    })

    mapRef.current.map.on('style.load', () => {
      setMapLoaded(true)
      onLoad && onLoad(mapRef.current.map)
    })
  }, [])

  const containerRef = useMemo(
    () => handleMount(mountMap, () => mapRef.current.map && mapRef.current.map.remove()),
    [mountMap]
  )

  useEffect(() => {
    if (!mapLoaded) return
  }, [mapLoaded, center, zoom])

  useEffect(() => {
    if (!mapLoaded) {
      return
    }

    if (mapRef.current.marker) {
      if (marker) {
        mapRef.current.marker.setLngLat(marker)
      } else {
        mapRef.current.marker.remove()
        mapRef.current.marker = null
      }

      return
    }

    if (marker) {
      mapRef.current.marker = new mapboxgl.Marker().setLngLat(center).addTo(mapRef.current.map)
    }
  }, [mapLoaded, marker])

  const data = useMemo(() => ({ containerRef, mapLoaded, mapRef, state, setState }), [
    mapLoaded,
    state
  ])

  return data
}
